import aboutUs from "./AboutusShow";
import NavBar from "./NavBarShow";
import Footer from "./FooterShow";
import heroSection from "./HeroSectionShow";
import story from "./StoryShow";
import ServicesSection from "./ServicesSection";
import breadcrumbs from "./Breadcrumbs";
// import address from "./Address";
import certificate from "./Certificate.jsx";
import instatoken from "./instatoken.jsx";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	aboutUs,
	ServicesSection,
	"Services-section": ServicesSection,
	heroSection,
	story,
	Footer,
	NavBar,
	breadcrumbs,
	"contact-us": breadcrumbs,
	certificate,
	instatoken,
	// address,
};
